import { render } from "./PaperHistory.vue?vue&type=template&id=f14e6d5e"
import script from "./PaperHistory.vue?vue&type=script&lang=js"
export * from "./PaperHistory.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1353221341/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__